import { Injectable } from '@angular/core';
import { JSONPath } from 'jsonpath-plus';

@Injectable({
	providedIn: 'root'
})
export class JPathService {
	constructor() {
		//
	}

	/**
	 * Wraper for jsonPath-plus value
	 * 
	 * @param json JSON document
	 * @param path JsonPath path expression
	 */
	getValue(json: any, path: string): any {
		const result = JSONPath({
			path,
			json,
			wrap: false
		});

		if (result && Array.isArray(result)) {
			return result[0];
		}

		return result;
	}

	/**
	 * Wraper for jsonPath-plus value
	 * 
	 * @param json JSON document
	 * @param path JsonPath path expression
	 */
	getQuery(json: any, path: string): any {
		const result = JSONPath({
			path,
			json
		});

		return result;
	}
}
